import { isWebsiteBuilderNodeType, TWebsiteBuilderNodeType } from "../../../nodes/websiteBuilderNode";

export interface IWebsiteBuilderMigrationNode {
  type: TWebsiteBuilderNodeType;
  children?: IWebsiteBuilderMigrationNode[];
}

export interface IWebsiteBuilderSchemaVersionMigrationNode extends IWebsiteBuilderMigrationNode {
  schemaVersion: number;
}

export function isWebsiteBuilderSchemaVersionMigrationNode(node: any): node is IWebsiteBuilderSchemaVersionMigrationNode {
  return isWebsiteBuilderNodeType(node?.type) && node?.schemaVersion != null;
}